import React, { createContext, useContext, useState, useEffect } from 'react';

const DemoModeContext = createContext();

export const useDemoMode = () => {
  const context = useContext(DemoModeContext);
  if (!context) {
    throw new Error('useDemoMode must be used within DemoModeProvider');
  }
  return context;
};

export const DemoModeProvider = ({ children }) => {
  // Get initial demo mode from localStorage, default to false
  const [isDemoMode, setIsDemoMode] = useState(() => {
    const saved = localStorage.getItem('solosocial_demo_mode');
    return saved ? JSON.parse(saved) : false;
  });

  // Persist demo mode state to localStorage
  useEffect(() => {
    localStorage.setItem('solosocial_demo_mode', JSON.stringify(isDemoMode));
    
    // Dispatch custom event so other components can react to demo mode changes
    window.dispatchEvent(new CustomEvent('demoModeChanged', { 
      detail: { isDemoMode } 
    }));
  }, [isDemoMode]);

  const toggleDemoMode = () => {
    setIsDemoMode(!isDemoMode);
  };

  const enableDemoMode = () => {
    setIsDemoMode(true);
  };

  const disableDemoMode = () => {
    setIsDemoMode(false);
  };

  const value = {
    isDemoMode,
    toggleDemoMode,
    enableDemoMode,
    disableDemoMode
  };

  return (
    <DemoModeContext.Provider value={value}>
      {children}
    </DemoModeContext.Provider>
  );
};

export default DemoModeProvider; 